<template>
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <h3 class="card-title"><i class="ti-user"></i> {{ $t('Invitees') }}</h3></div>
          <div class="ml-auto">
            <button v-on:click="addUser" type="button" class="btn btn-sm btn-rounded btn-info"><i class="ti-plus"></i> {{ $t('Add invitee') }}</button>
          </div>
        </div>
        <div class="table-responsive m-t-20">
          <table class="table vm no-th-brd pro-of-month">
            <tbody>
            <tr v-for="(invitee, index) in invitee_data">
              <td style="width:50px;">
                <toggle-button :value="invitee.meeting_user_id !== null" @change="updatePresence(index)"></toggle-button>
              </td>
              <td style="width:50px;">
                <!-- TODO: Remove test.achiev.eu -->
                <span class="round"><img :src="invitee.photo" alt="user" width="50" height="50"></span>
              </td>
              <td>
                <h6>{{ invitee.firstname }} {{ invitee.lastname }}</h6><small class="text-muted">{{ invitee.Units | unitFormatter }}</small>
              </td>
              <td>
                <div v-if="!invitee.in_norm">
                  <a @click="updatePresence(index)">{{ $t('Remove') }}</a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="add_user" class="row">
          <div class="col-sm-12 col-xs-12">
            <div class="m-t-20">
              <div class="form-group row">
                <label for="action-title" class="col-sm-12 control-label">{{ $t('Invite other invitees:') }}</label>
              </div>
              <div class="form-group row">
                <div class="col-sm-8">
                  <div class="input-group">
                    <select v-model="selectedUser" id="action-title" class="form-control btn-rounded action-owner">
                      <option v-if="user_data.length === 0" value="0" selected="true" disabled="disabled">{{ $t('All users are in the meeting') }}</option>
                      <option v-else selected="true" value="0" disabled="disabled">{{ $t('Select a collegue') }}</option>
                      <option v-for="user in user_data" :value="user">{{ user.firstname }} {{ user.lastname }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-sm btn-rounded btn-info" v-on:click="addInvitee"><i class="ti-plus"></i> {{ $t('Add') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";

  export default {
    name: "InviteeWidget",
    props: {
      'invitees' : {
        default: [],
        type: Array
      },

      'meeting_uid' : {
        default: "",
        type: String
      }
    },
    data: function () {
      return {
        meeting: "",
        invitee_data: {},
        remove_attendee: this.remove,
        user_data: [],
        selectedUser: 0,
        add_user: false,
        added_invitees: []
      }
    },
    created() {
      this.invitee_data = this.invitees;
      this.meeting = this.meeting_uid;
      this.getAllUsers();
    },
    methods: {
      // Grabs all the users
      getAllUsers: function () {
        let vm = this;
        apiHelper.getResource("/api/user").then((data) => {
          vm.user_data = data.data;
          vm.filterUsers();
        });
      },

      // Filters the users that are already in the meeting so that they don't appear twice
      filterUsers: function () {
        let vm = this;
        let att_list = [];
        let users = [];

        for (let i = 0; i < vm.invitee_data.length; i) {
          att_list.push(vm.invitee_data[i].uid);
        }

        for (let i = vm.user_data.length - 1; i >= 0; i--) {
          let index = att_list.indexOf(vm.user_data[i].uid);
          if (index === -1) {
            users.push(vm.user_data[i]);
            //vm.user_data.splice(index, 1);
          }
        }
		// Reverse array back
        vm.user_data = users.reverse();
      },

      // Adds an invitee to the meeting
      addInvitee: function () {
        let vm = this;
        let data_to_send = {
          "user_uid": vm.selectedUser.uid,
          "present": 0
        };

        apiHelper.postResource("/api/meeting/" + vm.meeting_uid + "/invitee", data_to_send).then((data) => {
          if (data.status !== 422) {
            data['added'] = 1;
            vm.invitee_data.push(data);

            let index = vm.user_data.indexOf(vm.selectedUser);
            vm.user_data.splice(index, 1);
            vm.selectedUser = 0;
          }
        });
      },

      // Function to make you add a user
      addUser: function () {
        this.add_user = !this.add_user;
      },

      // Update the presence of a user
      updatePresence: function(value) {
        let vm = this;
        let x = vm.invitee_data[value]['meeting_user_id'];

        if (x !== null) {
          apiHelper.delResource("/api/meeting/" + vm.meeting_uid + "/invitee/" + vm.invitee_data[value]['meeting_user_id']).then((data) => {
            if (data === 1) {
              vm.invitee_data[value]['added'] = 0;
              vm.invitee_data[value]['meeting_user_id'] = null;
              if (!vm.invitee_data[value]['in_norm']) {
                vm.invitee_data.splice(value, 1);
              }
              vm.getAllUsers();
            }
          });
        } else {
          let data_to_send = {
            "user_uid": vm.invitee_data[value].uid,
            "present": 0
          };

          apiHelper.postResource("/api/meeting/" + vm.meeting_uid + "/invitee", data_to_send).then((data) => {
            vm.invitee_data[value]['added'] = 1;
            vm.invitee_data[value]['meeting_user_id'] = data.meeting_user_id;
          });
        }
      }
    },
    computed: {
      // Find the height for the scrollbox of the actions
      findHeight: function () {
        if (this.invitee_data.length > 2) {
          return "overflow-y: scroll; height: 240px;"
        } else {
          let h = String(this.invitee_data.length * 80);
          return "overflow-y: hidden; height: " + h + "px;";
        }
      }
    },
    watch: {
      invitees: function (value) {
        this.invitee_data = value;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/InviteeWidget.vue